import { Permisos } from "./ClasesGrales";
class UsrLogged {
  constructor() {
    this.id = "";
    this.nombre = "";
    this.email = "";
    this.horassemana = 0;
    this.rol = "";
    this.foto = "";
    this.url = "";
    this.isLogged = false;
    this.permisos = new Permisos();
  }

  logIN(u, p) {
    this.isLogged = true;
    this.id = u.id;
    this.nombre = u.nombre;
    this.email = u.email;
    this.rol = u.rol;
    this.horassemana = u.horassemana;
    this.url = u.url;
    this.foto = u.foto;
    this.permisos = { ...p };
  }

  logOUT() {
    this.isLogged = false;
    this.id = "";
    this.nombre = "";
    this.email = "";
    this.rol = "";
    this.horassemana = 0;
    this.url = "";
    this.foto = "";
    this.permisos = {};
  }
}
export default UsrLogged;
